// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconClose = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
            <path
                fill="currentColor"
                d="M14.6296765,13.0846595 C15.0688478,13.5226888 15.0688478,14.2333838 14.6296765,14.6714603 C14.1905052,15.1095368 13.4779574,15.1094896 13.0387389,14.6714603 L7.49998873,9.10596908 L1.92186373,14.6695898 C1.48269171,15.1076191 0.770144641,15.1076191 0.33092612,14.6695898 C-0.108292401,14.2315604 -0.108245909,13.5208654 0.33092612,13.0827889 L5.91092581,7.52103877 L0.329379022,1.91534053 C-0.109793007,1.47731116 -0.109793007,0.766616152 0.329379022,0.328539689 C0.768551052,-0.109536772 1.48109812,-0.109489687 1.92031664,0.328539689 L7.49998873,5.93610844 L13.0781137,0.372487732 C13.517285,-0.0655416447 14.2298328,-0.0655416447 14.6690513,0.372487732 C15.1082699,0.810517109 15.1082227,1.52121212 14.6690513,1.95928858 L9.08905095,7.52103877 L14.6296765,13.0846595 Z"
            />
        </svg>
    );
};

export default React.memo(IconClose);
